import React from 'react';
import {Box, TextField} from '@mui/material';
import PropTypes from 'prop-types';
import RequiredCheckbox from './Shared/RequiredCheckbox';
import RichEditor from './Shared/RichEditor';
import RichEditorResultText from './Shared/RichEditorResultText';

const TextBox = ({
                     index,
                     id,
                     value,
                     onChange,
                     description,
                     isEditMode,
                     enableValidation,
                     isFormArchived,
                     readonly,
                     placeholderValues,
                     accessLevel
                 }) => {
    return (<Box>
        {isEditMode
            ? <>
                <RichEditor value={description} onChange={onChange} index={index} isEditMode={isEditMode}
                            isFormLive={isFormArchived} accessLevel={accessLevel}/>
                <RequiredCheckbox enableValidation={enableValidation} index={index} onChange={onChange}
                                  isFormArchived={isFormArchived}/>
            </>
            : <>
                <RichEditorResultText description={description} placeholderValues={placeholderValues}
                                      readonly={readonly} enableValidation={enableValidation}/>
                <TextField fullWidth value={value} required={enableValidation} multiline
                           onChange={e => onChange({id, value: e.target.value})}/>
            </>}
    </Box>);
};

TextBox.propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    index: PropTypes.number,
    description: PropTypes.string,
    enableValidation: PropTypes.bool,
    onChange: PropTypes.func,
    isEditMode: PropTypes.bool,
    isFormArchived: PropTypes.bool,
    readonly: PropTypes.bool,
    placeholderValues: PropTypes.object,
    accessLevel: PropTypes.number,
};

export default TextBox;